
import { useLinked } from "@type-r/react";
import { PopupIODialog, PrimaryButton } from "lqx-react";
import React from "react";
import { InmatchPermission, InvoiceManagementPermission, localUserInfo, ParticipantRoles } from "api";

export enum SelectedCpTab {
    Invoicing = '0',
    StatementOfAccount = '1',
    PaymentAndRaProfile = '2',
    AllowableDiscountsAndTolerances = '3',
    ExternalContacts = '4'
}

export const canView = (relationshipId: number, tab: SelectedCpTab): Boolean => {
    if (localUserInfo.hasRole('Admin')) return true;

    switch (tab) {
        case SelectedCpTab.Invoicing:
        case SelectedCpTab.StatementOfAccount:
        case SelectedCpTab.ExternalContacts:
            return localUserInfo.hasSomePermissions(
                "InvoiceManagement",
                ParticipantRoles.Supplier,
                [InvoiceManagementPermission.SupplierRead],
                null,
                relationshipId
            );
        default:
            return false;
    }
}

export const canEdit = (relationshipId: number, selectedTab: string): Boolean => {
    if (localUserInfo.hasRole('Admin')) return true;

    switch (selectedTab) {
        case SelectedCpTab.Invoicing:
        case SelectedCpTab.ExternalContacts:
        case SelectedCpTab.StatementOfAccount:
            return localUserInfo.hasSomePermissions(
                "InvoiceManagement",
                ParticipantRoles.Supplier,
                [
                    InvoiceManagementPermission.SupplierSuperSupplier,
                    InvoiceManagementPermission.SupplierWrite,
                    InvoiceManagementPermission.SupplierApprover
                ],
                null,
                relationshipId
            );
        case SelectedCpTab.PaymentAndRaProfile:
        case SelectedCpTab.AllowableDiscountsAndTolerances:
            return localUserInfo.hasSomePermissions(
                "Inmatch",
                ParticipantRoles.Supplier,
                [
                    InmatchPermission.SupplierManager,
                    InmatchPermission.SupplierAnalyst
                ],
                null,
                relationshipId
            );
        default:
            return false;
    }
}

export const showTab = (relationshipId: number, tab: SelectedCpTab): Boolean => {
    return (canView(relationshipId, tab) || canEdit(relationshipId, tab));
}

export const CpSaveButton = ({ onClick, label, isDisabled=false }) => {

    const $isOpen = useLinked(false);

    return (
        <>
            <PrimaryButton onClick={$isOpen.true} disabled={isDisabled}>Save</PrimaryButton>
            {$isOpen.value ? <CpSaveDialog $isOpen={$isOpen} onClick={onClick} label={label} /> : null}
        </>
    )
};

const CpSaveDialog = ({ $isOpen, onClick, label }) => {

    return (
        <PopupIODialog
            title="Save"
            $isOpen={$isOpen}
            actionLabel="Yes"
            success="Success!"
            doIO={onClick}
            hideTitleOnSuccess
        >
            {label}
        </PopupIODialog>
    );
};